import { Paper } from '@material-ui/core'
import React from 'react'
import ActivityQuestion from './component'
import { activityQuestions } from '../data'
const Activities = () => {
    return (
        <Paper elevation={5} style={{ background: '#dfdfdf', padding: '20px', minWidth: '500px' }}>
            <h2>Activity Questions</h2>
            How much would you like to do the following tasks?
            {activityQuestions.map((value, key) => (
                <ActivityQuestion id={key} key={key} question={value} />
            ))}
        </Paper>
    )
}


export default Activities